module.exports = __webpack_public_path__ + "media/images/home/notification-78088b593a90ae4a9e026bfa384e5be8.svg";